<template>
  <b-row>
    <input
      id="importSpreadSheet"
      ref="importSpreadSheet"
      type="file"
      class="d-none"
      accept=".csv"
      name="importSpreadSheet"
      @change="ImportInvoiceFile()"
    />

    <div class="col-12 col-sm-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <b-row>
            <b-col cols="12">
              <b-alert v-if="isuploading" show variant="warning"><b>File is uploading... please wait...</b></b-alert>
              <b-form-group v-else label="File:">
                <label v-if="!itemForm.invoiceExcelUrl" for="importSpreadSheet" class="btn btn-secondary"
                >Upload <b>Landmark - Mercury (Netherlands) Invoice</b> File</label>
                <div v-else>
                  <b-button variant="success"><i class="fa fa-excel"></i>UPS File Uploaded!</b-button>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <router-link
          :disabled="savingItem"
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'Billing.CarrierInvoices.Index' }"
        >
          <span>Back</span>
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>

import { mapGetters } from 'vuex';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [crudMixinGen('billing/carrierInvoices'), myCommonDataMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    isuploading: false,
    heading: 'Upload Invoice File',
  }),

  computed: {
    ...mapGetters('account', ['getUserData', 'isLoggedIn'])
  },

  mounted() {
    if (this.id) {
      this.ResetForm();
      this.LoadItem(this.id);
    } else {
      this.ResetForm();
      let queryHas = this.$route.query;
      if (queryHas) {
        if(queryHas.brandId) {
          this.itemForm.brandId = queryHas.brandId;
        }
      }
    }
  },

  methods: {
    ImportInvoiceFile() {
      let $this = this;
      let reader = new FileReader();
      $this.isuploading = true;
      let filePicked = this.$refs.importSpreadSheet.files[0];
      reader.onload = function(e) {
        let formData = new FormData();
        formData.append('formFile', filePicked);
        //formData.append("projectId", $this.projectId);
        $this.$http
          .post('/importUpsFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(resp => {
            $this.isuploading = false;
            if (resp.data.success) {
              $this.$router.push({ name: 'Billing.CarrierInvoices.Index' });
              $this.$swal('UPS File should start processing soon!');
            } else {
              $this.$swal('Something went wrong');
            }
          })
          .catch(err => {
            $this.isuploading = false;
            $this.$swal('Something went wrong');
          });
      };
      reader.readAsDataURL(filePicked);
    }
  }
};
</script>
